import { Buffer } from "buffer";

export const generateImage = async (
  prompt,
  style_id = 28,
  aspect_ratio = "1:1",
  negative_prompt = "",
  cfg = "",
  seed = "",
  steps = "",
  high_resolution = 0
) => {
  try {
    const url = "https://api.vyro.ai/v1/imagine/api/generations";
    let headers = new Headers();
    headers.append(
      "Authorization",
      "Bearer vk-3pOc4wrEyLpCCGisxfJWQACM9DIBrg2I3iQZQEByBnkyav"
    );

    let formdata = new FormData();
    formdata.append("prompt", prompt);
    formdata.append("style_id", style_id);
    formdata.append("seed", seed);
    formdata.append("cfg", cfg);
    formdata.append("steps", steps);
    formdata.append("negative_prompt", negative_prompt);
    formdata.append("aspect_ratio", aspect_ratio);
    formdata.append("high_res_results", high_resolution);

    let requestOptions = {
      method: "POST",
      body: formdata,
      headers: headers,
    };
    console.log(1);
    console.log("this is aspect_ration", aspect_ratio);
    console.log("this is style_id", style_id);
    console.log("THis is negative propmt", negative_prompt);
    console.log("THis is propmt", prompt);
    console.log("this is CFG", cfg);
    console.log("this is steps", steps);
    console.log("this is High", high_resolution);
    console.log("this is seed", seed);

    const response = await fetch(url, requestOptions);
    const result = await response.arrayBuffer();
    console.log("2");
    console.log("This is result ", result);

    const base64 = Buffer.from(result, "binary").toString("base64");
    const asImageSrc = `data:image/png;base64,${base64}`;
    return asImageSrc;
  } catch (error) {
    console.error("Error generating image:", error);
  }
};

export const uploadImageGeneration = async (
  prompt,
  style_id,
  selectedImage,
  type = "variation",
  strength = "",
  control = "",
  steps = "",
  cfg = "",
  negative_prompt = "",
  url = "https://api.vyro.ai/v1/imagine/api/edits/remix"
) => {
  let headers = new Headers();
  headers.append(
    "Authorization",
    "Bearer vk-3pOc4wrEyLpCCGisxfJWQACM9DIBrg2I3iQZQEByBnkyav",
    "Content-Type multipart/form-data"
  );

  let asImageSrc = "";
  try {
    const file = {
      uri: URL.createObjectURL(selectedImage),
      name: selectedImage.name,
      type: selectedImage.type,
    };
    const formData = new FormData();
    formData.append("image", selectedImage);
    console.log("Hello i am the file", file);

    if (type === "variation") {
      console.log("i am  not here");
      formData.append("prompt", prompt);
      formData.append("style_id", "21");
    } else if (type === "remix") {
      console.log("i am here");
      url = "https://api.vyro.ai/v1/imagine/api/edits/remix";
      formData.append("prompt", prompt);
      formData.append("style_id", style_id);
      formData.append("strength", strength);
      formData.append("control", control);
      formData.append("steps", steps);
      formData.append("cfg", cfg);
      formData.append("negative_prompt", negative_prompt);

      console.log("prompt", prompt);
      console.log("style_id", style_id);
      console.log("strength", strength);
      console.log("control", control);
      console.log("steps", steps);
      console.log("cfg", cfg);
    }
    let requestOptions = {
      method: "POST",
      body: formData,
      headers: headers,
    };

    console.log(formData);
    console.log("1");
    console.log("hitting on url ", url);

    const response = await fetch(url, requestOptions);
    const result = await response.arrayBuffer();
    console.log("2");
    console.log("This is result ", result);

    const base64 = Buffer.from(result, "binary").toString("base64");
    asImageSrc = `data:image/png;base64,${base64}`;

    return asImageSrc;
  } catch (error) {
    console.error(error);
    alert("Error", "Something went wrong");
    return { error: error };
  }
};
